<template>
  <tr>
    <td colspan="3" class="text-left">
      <div class="confection-inputs">
        <basic-input
          validationRule="required|max:50"
          name="confection-granting-company-name"
          labelClass="mb-2"
          label="Skrócona nazwa firmy"
          inputType="text"
          v-model="grantingCompanyName"
        />
        <basic-textarea
          validationRule="max:110"
          name="confection-granting-reason"
          labelClass="mb-2"
          label="Powód przekazania w języku polskim"
          v-model="grantingReason"
          rows="2"
        />
        <basic-textarea
          validationRule="max:110"
          name="confection-granting-reason-en"
          labelClass="mb-2"
          label="Powód przekazania w języku angielskim"
          v-model="grantingReasonEn"
          rows="2"
        />
        <basic-textarea
          validationRule="max:110"
          name="confection-granting-reason-ua"
          labelClass="mb-2"
          label="Powód przekazania w języku ukraińskim"
          v-model="grantingReasonUa"
          rows="2"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import BasicTextarea from '../Inputs/basicTextarea.vue';
import BasicInput from '../Inputs/basicInput.vue';

export default {
  name: 'NDEConfectionGrantingForm',
  components: {
    BasicTextarea,
    BasicInput,
  },
  computed: {
    ...mapFields('confection', [
      'grantingCompanyName',
      'grantingReason',
      'grantingReasonEn',
      'grantingReasonUa',
    ]),
  },
};
</script>
